// useReinstateWrongSite - reverse a wrong-site EXCLUSION: flip the upload back to
// active, re-promote its cached facts, and set a standing override so the gate
// won't re-quarantine it. The human twin of useRestoreUpload (which re-admits an AI
// quarantine). Refreshes the uploads list and ops dashboard.
import { useMutation, useQueryClient } from "react-query";

import { queryKeys } from "../queryKeys";
import { useAgentsHttp } from "../useAgentsHttp";
import { invalidateOperationsDashboard } from "./useOperationsDashboard";

export interface ReinstateWrongSiteInput {
  upload_id: string;
  user_email?: string;
}

interface ReinstateWrongSiteResult {
  reinstated: boolean;
  upload_id: string;
  project_id: string;
}

export const useReinstateWrongSite = (projectId: string) => {
  const http = useAgentsHttp();
  const qc = useQueryClient();
  return useMutation<ReinstateWrongSiteResult, Error, ReinstateWrongSiteInput>(
    async (payload) =>
      http<ReinstateWrongSiteResult>("/uploads/reinstate-wrong-site", payload),
    {
      onSuccess: () => {
        qc.invalidateQueries({
          queryKey: queryKeys.uploadsList(projectId),
        });
        invalidateOperationsDashboard(qc);
      },
    },
  );
};
